import React from 'react';
import Button from '@material-ui/core/Button';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PropTypes from 'prop-types';

// app modules: components
import Link from 'components/Link';
import ServerError from 'components/Error/ServerError';

const NoHitsCustom = props => {
  const { query, suggestion } = props;
  return query ? (
    <ServerError
      title={`No results found for ${query}`}
      icon={<NotInterestedIcon color="secondary" fontSize="inherit" />}
    >
      {suggestion ? (
        <p>
          Did you mean{' '}
          <Link to={`/search?q=${suggestion}`} className="link link--energized">
            {suggestion}
          </Link>?
        </p>
      ) : null}
    </ServerError>
  ) : null;
};

NoHitsCustom.propTypes = {
  query: PropTypes.string.isRequired,
  suggestion: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

NoHitsCustom.defaultProps = {
  suggestion: false,
};

export const NoHitsCustomError = props => {
  const { errorLabel, tryAgainLabel, resetSearchFn } = props;
  return (
    <ServerError title="Oops...">
      <p className="margin-bottom-10">{errorLabel}</p>
      <Button variant="contained" color="primary" size="large" onClick={resetSearchFn}>
        {tryAgainLabel}
      </Button>
    </ServerError>
  );
};

NoHitsCustomError.propTypes = {
  errorLabel: PropTypes.string.isRequired,
  tryAgainLabel: PropTypes.string,
  resetSearchFn: PropTypes.func,
};

NoHitsCustomError.defaultProps = {
  tryAgainLabel: null,
  resetSearchFn: () => {},
};

export default NoHitsCustom;
